import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Modale de notification informant l'utilisateur que son brouillon
 * a été supprimé automatiquement suite à une inactivité de 5 jours.
 */
@Component({
  selector: 'app-modal-expired-draft',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Brouillon expiré</h4>
      <button type="button" class="close" aria-label="Fermer" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>
        <i class="fa fa-info-circle text-warning"></i>
        Votre brouillon a été supprimé automatiquement après <strong>5 jours d'inactivité</strong>.
      </p>
      <p>Vous pouvez recommencer la saisie de votre déclaration.</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="activeModal.close()">Compris</button>
    </div>
  `
})
export class ModalExpiredDraftComponent {
  constructor(public activeModal: NgbActiveModal) {}
}



// WEBPACK FOOTER //
// ./src/app/components/modal-expired-draft/modal-expired-draft.component.ts